import { CardBadge } from '#/shared/api/generated/billing/models'
import {
  CardAmexIcon,
  CardMastercardIcon,
  CardVisaIcon,
} from '#/shared/ui/icons'

export const CARD_BRAND = {
  visa: 'visa',
  mastercard: 'mastercard',
  amex: 'amex',
} as const

export type CardBrand = (typeof CARD_BRAND)[keyof typeof CARD_BRAND]

export interface SavedCard {
  id: string
  brand: CardBrand
  last4: string
  holderName: string
  expiry: string
  isDefault: boolean
  badge: CardBadge
  updatedAt: string
}

export const CARD_BADGE_LABEL_KEY: Record<CardBadge, string> = {
  [CardBadge.card_on_file]: 'settlePayment.card.badge.cardOnFile',
  [CardBadge.cca_on_file]: 'settlePayment.card.badge.ccaOnFile',
}

export const CARD_BRAND_ICON: Record<CardBrand, typeof CardVisaIcon> = {
  [CARD_BRAND.visa]: CardVisaIcon,
  [CARD_BRAND.mastercard]: CardMastercardIcon,
  [CARD_BRAND.amex]: CardAmexIcon,
}

export const CARD_BRAND_LABEL: Record<CardBrand, string> = {
  [CARD_BRAND.visa]: 'Visa',
  [CARD_BRAND.mastercard]: 'Mastercard',
  [CARD_BRAND.amex]: 'Amex',
}
